module.exports = __webpack_public_path__ + "img/sr.41872cfa.svg";